import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import FormData from 'form-data';

import { authSetFile } from '../../utils/request';

const uploadFile = createAsyncThunk(
  'general/uploadFile',
  async ({ file } = {}, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      return await authSetFile('/compatibility/upload', formData, {
        'Content-Type': 'multipart/formdata',
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const clearUploadFile = createAction('clearUploadFile');

export default uploadFile;
